
import { useContext, useEffect, useMemo, useRef, useState } from "react"
import services from "../../../services/services";
import { Urls } from "../../../services/Urls";
import { callautopopulate } from "../../../services/callautopop";
import { calculateWordsFromString, secondsToHours } from "../../../utils/Helper";
import _ from "underscore";
import { useCommon } from "./useCommon";
import { ToastContext } from "../../../context/ToastContext";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import globalFilterStore from "../../../Store/globalFilterStore";

export const useReviewing = ({ getValuePermission }) => {
    const { showSuccess, showError, showInfo } = useContext(ToastContext);
    const { getSubProject } = useCommon();
    const [rowData, setRowData] = useState([]);
    const [productCode, setProjectCode] = useState(null)
    const [option, setOption] = useState({
        groupBy: [{ value: "feature", label: "Feature" }, { value: "IssueType", label: "Issue Type" }]
    });
    const tagRef = useRef(null)
    const [selectedHour, setSelectedHour] = useState(3);
    const [loader, setLoader] = useState(false);
    const [totalData, setTotalData] = useState(null);
    const [reviewData, setReviewData] = useState([]);
    const [reasonDetails, setReasonDetails] = useState({});
    const [revokePopup, setRevokePopup] = useState({
        show: false,
        data: ''
    })
    const [showPopup, setShowPopup] = useState({
        show: false,
        data: {},
        alloted: ''
    })
    const [selectedData, setSelectedData] = useState({});
    const [expandedGroups, setExpandedGroups] = useState({});
    const [declareConfirmation, setDeclareConfirmation] = useState({
        show: false,
        data: ''
    })
    const [selectedTab, setSelectedTab] = useState("bucket");
    const store = globalFilterStore();
    const { commonFilter, setCommonFilter, projectWiseData, setProjectWiseData } = store;
    const [filterValues, setFilterValues] = useState({ ...commonFilter });
    const [taskDetailsPopup, setTaskDetailsPopup] = useState({ show: false, hoveredId: 0 });

    const baseColumns = [
        {
            key: "",
            label: "",
            checkbox: true,
            style: { width: "50px", textAlign: "center" },
            headerStyle: { textAlign: "center", },
            sort: false,
            render: (row, isAll, issueTypeData, category) => {
                const rowId = row?.issue_id || row?.id;
                const issueTypeKey = category ? category : commonFilter?.groupBy === "feature" ? `${row?.features_issue_summary}-${row?.issue_type_name}` : `${row?.issue_type_name}-${row?.features_issue_summary}`;
                const issueTypeSelection = selectedData[issueTypeKey] || [];
                const isChecked = row?.id === "all" ? issueTypeSelection.includes(rowId) : issueTypeSelection.includes(rowId);
                const data = issueTypeData ? issueTypeData : commonFilter?.groupBy === "feature" ? rowData[row?.features_issue_summary]?.issue_types[row?.issue_type_name] : rowData[row?.issue_type_name]?.issue_types[row?.features_issue_summary]
                return (
                    <div className="d-flex justify-content-center">
                        <input
                            type="checkbox"
                            className="input-dd"
                            // disabled={isDisabled}
                            checked={isChecked}
                            onChange={() => handleCheckboxChange(row, isAll, data, issueTypeKey)}
                        />
                    </div>
                );
            },


        },
        {
            key: "issue_key",
            label: "Task ID",
            style: { width: "100px", textAlign: "center" },
            headerStyle: { textAlign: "center" },
            render: (row) => {
                const isHovered = taskDetailsPopup?.hoveredId === row?.issue_id;
                return <div className="d-flex justify-content-between align-items-center pe-1" onMouseEnter={() => setTaskDetailsPopup((prev) => ({ ...prev, hoveredId: row?.issue_id }))} onMouseLeave={() => setTaskDetailsPopup((prev) => ({ ...prev, hoveredId: 0 }))}>
                    <div className={`d-flex gap-2 align-items-center ${isHovered ? "w90" : "w100"}`}>
                        <img src={row?.issue_type_image_url} alt="" width={16} height={16} />
                        <div className="c-pointer fw-semibold text-decoration-underline text-truncate" onClick={() => setTaskDetailsPopup((prev) => ({ ...prev, show: true, data: row }))} >{row?.issue_key}</div>
                    </div>
                    {isHovered && <a href={row?.issue_url} target="_blank" className="w10 text-secondary"><FontAwesomeIcon icon="fa-solid fa-link" /></a>}
                </div>
            }
        },
        {
            key: "issue_summary",
            label: "Task Name",
            style: { width: "200px", flex: 1 },
            render: (row) => {
                return <p title={row?.issue_summary} className=" text-truncate">{row?.issue_summary}</p>
            }
        },
        {
            key: "complexity",
            label: "Complexity",
            style: { width: "100px", textAlign: "center", },
            headerStyle: { textAlign: "center" },
            sort: false,
        },
        {
            key: "longitivity",
            label: "Longitivity",
            style: { width: "100px", textAlign: "center" },
            headerStyle: { textAlign: "center" },
            sort: false,
        },
    ];

    useEffect(() => {
        callautopopulate("projects", "issue_complexity", "issue_logitivity", "bid_seconds", "user_info", "agile_planning_review_reasons").then((res) => {
            res?.bid_seconds?.forEach(item => {
                item.label = secondsToHours(item.bid_seconds);
            });
            setOption((prev) => ({
                ...prev,
                complexity: _.sortBy(res?.issue_complexity, 'order_number'),
                logitivity: _.sortBy(res?.issue_logitivity, 'order_number'),
                estimate: res?.bid_seconds,
                projects: _.sortBy(res?.projects, "project_name"),
                userCode: res?.user_info[0]?.user_code,
                reasons: res?.agile_planning_review_reasons,
            }))
            if (commonFilter?.projects?.length > 0) {
                handleData(res?.user_info[0]?.user_code);
            } else {
                setOption((prev) => ({ ...prev, apiCall: true }));
            }
        })
    }, []);

    useEffect(() => {
        !_.isEqual(commonFilter, filterValues) && setCommonFilter({ ...commonFilter, ...filterValues });
    }, [filterValues])

    useEffect(() => {
        !_.isEqual(commonFilter, filterValues) && setFilterValues((prev) => ({ ...prev, ...commonFilter }));
    }, [commonFilter])

    const handleCheckboxChange = (row, isAll, issueTypeData, category) => {
        const rowId = row?.issue_id || row?.id;
        const issueTypeKey = category
        const currentIssueTypeSelection = selectedData[issueTypeKey] || [];
        let newSelection;
        setProjectCode(issueTypeData?.[0]?.product_code)
        if (isAll === "all") {
            if (currentIssueTypeSelection.includes("all")) {
                newSelection = [];
            } else {
                const allIssueIds = _.pluck(issueTypeData, "issue_id");
                newSelection = ["all", ...allIssueIds];
            }
        } else {
            if (currentIssueTypeSelection.includes(rowId)) {
                if (currentIssueTypeSelection.includes("all")) {
                    newSelection = currentIssueTypeSelection?.filter(id => id !== "all" && id !== rowId);
                } else {
                    newSelection = currentIssueTypeSelection?.filter(id => id !== rowId);
                }
            } else {
                newSelection = [...currentIssueTypeSelection.filter(id => id !== "all"), rowId];
                const allIssueIds = _.pluck(issueTypeData, "issue_id");
                const allIndividualSelected = allIssueIds.every(id => newSelection.includes(id));
                if (allIndividualSelected) {
                    newSelection = ["all", ...allIssueIds];
                }
            }
        }
        const newSelectedData = { ...selectedData };
        if (newSelection.length === 0) {
            delete newSelectedData[issueTypeKey];
        } else {
            newSelectedData[issueTypeKey] = [...new Set(newSelection)];
        }
        setSelectedData(newSelectedData);
    };

    // dynamic column
    const getDynamicBidderColumns = (allIssues) => {
        const allBidderNames = new Set();
        allIssues.forEach(issue => {
            if (issue.bidders && Array.isArray(issue.bidders)) {
                issue.bidders.forEach(bid => {
                    if (bid.user_display_name) {
                        const uniqueKey = `${bid.user_display_name}-${bid?.total_work_experience || 0}`;
                        allBidderNames.add(uniqueKey);
                    }
                });
            }
        });

        return Array.from(allBidderNames).sort().map(uniqueKey => {
            const [name, year] = uniqueKey.split('-');
            return {
                key: `bidder_${name}`,
                label: `${name} (${year})`,
                style: { width: "150px", maxWidth: "150px", textAlign: "center", whiteSpace: "nowrap", flexShrink: 5, padding: 0 },
                headerStyle: { whiteSpace: "wrap", overflow: "hidden", textAlign: "center", padding: 0 },
                className: "bid-col",
                sort: false,
                render: (row) => {
                    const bidder = row.bidders?.find(b => b.user_display_name === name);
                    if (bidder) {
                        const isWinner = row.winner_user_code === bidder.user_code && row.alloted_user_code === bidder?.user_code;
                        const isAllocate = row.alloted_user_code === bidder.user_code && row.winner_user_code !== bidder.user_code;
                        const isWinnerButNotAssign = row.winner_user_code === bidder.user_code && row.alloted_user_code !== bidder?.user_code;

                        return (
                            <div className="d-flex gap-2 align-items-center justify-content-center text-center m-0 "
                                style={{ background: selectedTab === "workspace" ? "transparent" : isWinner ? "#dcfce7" : isAllocate ? "#fef9c3" : isWinnerButNotAssign ? "#c7d2fe" : "" }}>
                                <span className="fs-12px">
                                    {bidder.bid_info || `${bidder.bid_seconds / 3600}h`}
                                </span>
                                {selectedTab === "bucket" && <input
                                    type="checkbox"
                                    className="input-dd"
                                    checked={row.alloted_user_code === bidder.user_code}
                                    onChange={(e) => {
                                        if (bidder?.user_code !== row.winner_user_code) {
                                            setShowPopup({ show: true, data: row, alloted: bidder.user_code, estimate: row?.time_left_seconds });
                                        } else {
                                            row.alloted_user_code !== bidder.user_code && resultDeclare(row, bidder?.user_code)
                                        }
                                    }}
                                />}
                            </div>
                        );
                    }
                    return <span className="text-muted">-</span>;
                }
            };
        });
    };

    // revoke column
    const revokeColumn = [
        {
            key: "time_matrix",
            label: "Time Matrix",
            style: { width: "100px", textAlign: "center" },
            headerStyle: { textAlign: "center" },
            hide: getValuePermission("time_matrix_column") || !commonFilter?.taskType,
            render: (row) => {
                return (
                    <p className="fw-bold">{row?.matrix_range}</p>
                );
            }
        },
        {
            key: "revoke",
            label: "Revoke",
            pinned: "right",
            style: { width: "60px", textAlign: "center", },
            headerStyle: { textAlign: "center" },
            sort: false,
            render: (row) => {
                return (
                    <div>
                        {(
                            <div onClick={() => {
                                if (row?.time_left_seconds > 0) {
                                    showInfo("Info", "Estimation time is not over.");
                                    return;
                                } else {
                                    setRevokePopup({
                                        show: true,
                                        data: [row?.issue_id],
                                        product_code: row?.product_code
                                    })
                                }

                            }} style={{ color: row?.time_left_seconds > 0 ? "gray" : "red", cursor: row?.time_left_seconds > 0 ? "auto" : "pointer" }}>
                                <FontAwesomeIcon icon="fa-solid fa-hand-point-left" />
                            </div>
                        )}
                    </div>
                )
            }
        },
    ]

    const handleData = async (userCode) => {
        const data = await getSubProject(commonFilter?.projects, ["is_sub_project", "is_issue_type", "is_reporter", "is_sprint"], userCode || option?.userCode);
        if (data) {
            setProjectWiseData(data);
            setOption((prev) => ({ ...prev, apiCall: true }));
        }
    }

    useEffect(() => {
        option?.apiCall && getReviewingDetails(null)
    }, [option?.apiCall])

    function formatBiddingData(rawData) {
        const isIssueTypeGrouping = commonFilter?.groupBy === "IssueType"
        const formattedData = {};

        rawData.forEach(item => {
            const groupKey = (isIssueTypeGrouping
                ? item.issue_type_name
                : item.features_issue_summary) || "Other";

            if (!formattedData[groupKey]) {
                formattedData[groupKey] = {
                    group_summary: (isIssueTypeGrouping
                        ? item.issue_type_name
                        : item.features_issue_summary) || "Other",
                    issue_types: {}
                };
            }

            const subGroupKey = (isIssueTypeGrouping
                ? item.features_issue_summary
                : item.issue_type_name) || "Other";

            if (!formattedData[groupKey].issue_types[subGroupKey]) {
                formattedData[groupKey].issue_types[subGroupKey] = [];
            }

            const existingIssueIndex = formattedData[groupKey].issue_types[subGroupKey]
                .findIndex(issue => issue.issue_id === item.issue_id);

            if (existingIssueIndex === -1) {
                const newIssue = {
                    issue_id: item.issue_id,
                    issue_key: item.issue_key,
                    issue_summary: item.issue_summary,
                    bidders: [],
                    winner_user_code: item.winner_user_code,
                    alloted_user_code: item.alloted_user_code ? item.alloted_user_code : item.winner_user_code,
                    lead_estimated_info: item.lead_estimated_info,
                    status_name: item.status_name,
                    issue_url: item.issue_url,
                    complexity: item.complexity,
                    longitivity: item.longitivity,
                    priority: item?.priority_name,
                    product_code: item?.product_code,
                    bucket_issue_id: item?.bucket_issue_id,
                    time_left_seconds: item?.time_left_seconds,
                    issue_type_name: item?.issue_type_name,
                    features_issue_summary: item?.features_issue_summary,
                    issue_type_image_url: item?.issue_type_image_url,
                    matrix_range: item?.matrix_range
                };

                newIssue.bidders.push({
                    user_code: item.user_code,
                    user_display_name: item.user_display_name,
                    bid_info: item.bid_info,
                    bid_seconds: item.bid_seconds,
                    submit_datetime: item.submit_datetime,
                    total_work_experience: item.total_work_experience || 0
                });

                formattedData[groupKey].issue_types[subGroupKey].push(newIssue);
            } else {
                formattedData[groupKey].issue_types[subGroupKey][existingIssueIndex].bidders.push({
                    user_code: item.user_code,
                    user_display_name: item.user_display_name,
                    bid_info: item.bid_info,
                    bid_seconds: item.bid_seconds,
                    submit_datetime: item.submit_datetime,
                    total_work_experience: item.total_work_experience || 0
                });
            }
        });

        return formattedData;
    }

    const getReviewingDetails = async (tabKey) => {

        try {
            setReviewData([])
            setLoader(true);
            const payload = {
                project_ids: commonFilter?.projects?.toString() || "",
                sub_project_ids: commonFilter?.subProject?.toString() || "",
                sprint_ids: commonFilter?.sprint?.toString() || "",
                issuetype_ids: commonFilter?.issueType?.toString() || "",
                issue_keys: commonFilter?.issueKey || "",
                reporter_user_code: commonFilter?.reporters?.toString() || "",
            }
            const res = await services.getInvokeRemote("POST", Urls("PGETBUCKETREVIEWDETAILS"), payload)
            if (!res?.body?.error_status) {
                const key = tabKey ? tabKey : selectedTab
                setReviewData(_.filter(res?.body?.data?.review_details, item => (key === "bucket" ? !item?.in_workspace : item?.in_workspace)));
                setOption((prev) => ({ ...prev, apiCall: false }));
                setLoader(false);
                setCommonFilter({ ...commonFilter, isChange: false })
            }
        } catch (error) {
            console.error("error:::", error)
            setLoader(false);
        }
    }

    useEffect(() => {
        if (reviewData?.length > 0) {
            const data = formatBiddingData(reviewData)
            let totalCount = 0;
            for (let group in data) {
                if (data[group].issue_types) {
                    for (let type in data[group].issue_types) {
                        totalCount += data[group].issue_types[type].length;
                    }
                }
            }
            setTotalData(totalCount);
            setRowData(data);
            setSelectedData({});
        } else {
            setRowData([])
        }

    }, [reviewData, commonFilter?.groupBy])

    const revokeSelectedIssue = () => {
        const data = Object.values(selectedData).flat().filter(id => id !== "all")
        if (data?.length <= 0) {
            showInfo("Info", "No issues selected!")
            return
        }
        setRevokePopup({
            show: true,
            data: data,
            product_code: productCode
        })
    }

    const resultDeclare = async (row, userCode) => {
        try {
            if (row?.winner_user_code !== userCode && _.isEmpty(reasonDetails?.reason)) {
                showInfo("Info", "Please select a reason.")
                return
            }
            if (!_.isEmpty(reasonDetails?.reason) && reasonDetails?.reason?.reason_type_key?.toLowerCase() === "other" && (!reasonDetails?.remark || calculateWordsFromString(reasonDetails.remark) < 2)) {
                showInfo("Info", "Remark should contain minimum 2 words.")
                return
            }

            const payload = {
                "issue_id": row?.issue_id,
                "product_code": row?.product_code,
                "winner_user_code": row?.winner_user_code,
                "winner_bid_seconds": _.find(row?.bidders, { user_code: row?.winner_user_code })?.bid_seconds,
                "alloted_user_code": userCode,
                "alloted_bid_seconds": _.find(row?.bidders, { user_code: userCode })?.bid_seconds,
                "remark": (reasonDetails?.reason?.reason_type_key?.toLowerCase() !== "other" ? reasonDetails?.reason?.reasons : reasonDetails?.remark) || ""
            }
            const res = await services.getInvokeRemote("POST", Urls("PUPSERTBUCKETDECLARESAVE"), payload)
            if (res.body.StatusCode === 400 || res.body.StatusCode === 204 || res.body.StatusCode === 202 || res.body.StatusCode === 401 ||
                res.body.StatusCode === 500) {
                showError("Error", res.body.errorMessage);
            } else {
                showSuccess("Success", res.body.message);
                setReasonDetails({});
                setShowPopup({ show: false })
                for (const groupName in rowData) {
                    const groupData = rowData[groupName];
                    if (groupData.issue_types) {
                        for (const issueType in groupData.issue_types) {
                            const issues = groupData.issue_types[issueType];
                            for (let i = 0; i < issues.length; i++) {
                                const issue = issues[i];
                                if (issue.issue_id === row?.issue_id) {
                                    issue.alloted_user_code = userCode;
                                    issue.time_left_seconds = 0
                                }
                            }
                        }
                    }
                }
            }
        } catch (error) {
            console.error(error)
            showError("Error", error?.response?.data?.errorMessage);
        }
    }

    const upsertBucketResultDeclare = async (data) => {
        try {
            const results = getDataObject(data);
            const tvpData = results.map(issue => ({
                issue_id: issue?.issue_id,
                winner_user_code: issue?.winner_user_code,
                alloted_user_code: issue?.alloted_user_code,
                product_code: issue?.product_code
            }));

            const payload = {
                "tvp_bucket_result_declare": tvpData,
                "is_declared": true,
            }
            const res = await services.getInvokeRemote("POST", Urls("UPSERTBUCKETRESULTDECLARE"), payload)
            if (res.body.StatusCode === 400 || res.body.StatusCode === 204 || res.body.StatusCode === 202 || res.body.StatusCode === 401 ||
                res.body.StatusCode === 500) {
                showError("Error", res.body.errorMessage);
            } else {
                showSuccess("Success", res.body.message);
                getReviewingDetails()
                setDeclareConfirmation({ show: false })
            }
        } catch (error) {
            console.error(error);
            showError("Error", error?.response?.data?.errorMessage);
        }
    }

    const CheckEstimate = (key) => {
        const data = Object.values(selectedData).flat().filter(id => id !== "all")
        const filteredData = _.uniq(_.filter(reviewData, item => data?.includes(item.issue_id) && item?.time_left_seconds > 0), "issue_id");
        if (data?.length <= 0) {
            showInfo("Info", "No issues selected!")
            return
        }
        if (key === "revoke") {
            if (filteredData?.length > 0) {
                showInfo("Info", `Estimation time is not over for: ${filteredData.map(val => val?.issue_key).join(", ")}`)
                return;
            }
            setRevokePopup({
                show: true,
                data: data,
                product_code: productCode
            })
        }
        if (key === "declare") {
            if (filteredData?.length > 0) {
                setDeclareConfirmation({
                    show: true,
                    message: `Estimation time is not over for: ${filteredData?.map(val => val?.issue_key)?.slice(0, 3).join(", ") + (filteredData?.length > 3 ? ` and ${filteredData?.length - 3} more` : "")}. Are you sure you want to still declare task.`,
                    data: data

                })
            } else {
                upsertBucketResultDeclare(data)
            }

        }

    }

    useEffect(() => {
        if (rowData && !loader) {
            const initialExpanded = {};
            Object.values(rowData).forEach(groupData => {
                initialExpanded[groupData?.group_summary] = true;
            });
            setExpandedGroups(initialExpanded);
        }
    }, [rowData, loader]);

    const toggleGroup = (groupSummary) => {
        setExpandedGroups(prev => ({
            ...prev,
            [groupSummary]: !prev[groupSummary]
        }));
    };

    const handleMoveToWorkspace = async (isConfirmed) => {
        try {
            const data = Object.values(selectedData).flat().filter(id => id !== "all")
            if (!isConfirmed) {
                if (data?.length <= 0) {
                    showInfo("Info", "No issues selected!")
                    return
                }
                // check for tasks with no bids
                const results = getDataObject(data);
                const noBidTasks = _.filter(results, item => item?.winner_user_code === 0);
                if (!_.isEmpty(noBidTasks)) {
                    showInfo("Info", `No bids is submitted in tasks: ${_.pluck(noBidTasks, "issue_key")?.join(", ")}`);
                    return;
                }

                // confirmation for tasks whose estimation time is not over
                const filteredData = _.uniq(_.filter(reviewData, item => data?.includes(item?.issue_id) && item?.time_left_seconds > 0), "issue_id");
                if (filteredData?.length > 0) {
                    setDeclareConfirmation({
                        show: true,
                        message: `Estimation time is not over for: ${filteredData?.map(val => val?.issue_key)?.slice(0, 3).join(", ") + (filteredData?.length > 3 ? ` and ${filteredData?.length - 3} more` : "")}. Are you sure you want to still move task to workspace.`,
                        data: data,
                        key: "workspace"
                    })
                    return;
                }
            }
            const payload = {
                issue_ids: data?.toString() || ""
            }
            const res = await services.getInvokeRemote("POST", Urls("SENDBUCKETWORKSPACE"), payload);
            if (!res?.body?.error_status) {
                showSuccess("Success", res?.body?.message);
                setDeclareConfirmation({ show: false, message: "", data: [] });
                getReviewingDetails();
            }

        } catch (error) {
            console.error("Error: ", error);
        }
    }

    const getDataObject = (selectedIdArray) => {
        const results = [];
        for (const issueId of selectedIdArray) {
            for (const [, groupData] of Object.entries(rowData)) {
                for (const [, issues] of Object.entries(groupData.issue_types)) {
                    const issue = issues.find(i => i.issue_id === issueId);
                    if (issue) {
                        results.push(issue);
                        break;
                    }
                }
            }
        }
        return results;
    }

    return useMemo(() => ({
        rowData, option, selectedHour, setSelectedHour, getReviewingDetails, tagRef, loader, handleData, projectWiseData, totalData, getDynamicBidderColumns, baseColumns, revokeColumn, resultDeclare, showPopup, setShowPopup, reasonDetails, setReasonDetails, revokePopup, setRevokePopup, revokeSelectedIssue, upsertBucketResultDeclare, CheckEstimate, declareConfirmation, setDeclareConfirmation, expandedGroups, toggleGroup, commonFilter, setCommonFilter, handleMoveToWorkspace, selectedTab, setSelectedTab, filterValues, setFilterValues, taskDetailsPopup, setTaskDetailsPopup
    }), [rowData, option, selectedHour, setSelectedHour, getReviewingDetails, tagRef, loader, handleData, projectWiseData, totalData, getDynamicBidderColumns, baseColumns, revokeColumn, showPopup, setShowPopup, resultDeclare, reasonDetails, setReasonDetails, revokePopup, setRevokePopup, revokeSelectedIssue, upsertBucketResultDeclare, CheckEstimate, declareConfirmation, setDeclareConfirmation, expandedGroups, toggleGroup, commonFilter, setCommonFilter, handleMoveToWorkspace, selectedTab, setSelectedTab, filterValues, setFilterValues, taskDetailsPopup, setTaskDetailsPopup])
}
